import {
  useFormErrorNotification,
  useFormSuccessNotification,
} from "@babackapp/react-hook-forms-components/form-notifications";
import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";
import useInvalidateShop from "./use-invalidate-shop";

export default function useRefreshShippingMethods(shopId: string) {
  const successNotification = useFormSuccessNotification();
  const errorNotification = useFormErrorNotification();
  const mutation = $api.useMutation("post", "/shops/{shopId}/exchanges/shipping-methods/refresh");
  const invalidateShop = useInvalidateShop(shopId);

  return useMutation({
    onSuccess: () => {
      invalidateShop();
      successNotification();
    },
    onError: () => {
      errorNotification();
    },
    mutationFn: async () => {
      return mutation.mutateAsync({
        params: { path: { shopId } },
      });
    },
  });
}
